import SubMenu from '../enums/subMenu'
import SubMenuRotas from '../enums/subMenuRotas';

export const getUrlSubMenu = tipo => {
    const urlOficioSituacao = "/ComunicacaoProcessual/OficioPorSituacao";
    const urlOficiosEnviados = "/ComunicacaoProcessual/OficiosEnviados";
    const urlProtocoloDeOficios = "/ComunicacaoProcessual/ProtocoloDeOficiosParaEnvio";

    switch (tipo) {

        //Ofício por Situação
        case SubMenu.LIXEIRA:
            return `${urlOficioSituacao}/${SubMenuRotas.LIXEIRA}`;

        case SubMenu.EM_EDICAO:
            return `${urlOficioSituacao}/${SubMenuRotas.EM_EDICAO}`;

        case SubMenu.EM_REVISAO:
            return `${urlOficioSituacao}/${SubMenuRotas.EM_REVISAO}`;

        case SubMenu.EM_CORRECAO:
            return `${urlOficioSituacao}/${SubMenuRotas.EM_CORRECAO}`;

        case SubMenu.EM_REVISAO_OFICIAL:
            return `${urlOficioSituacao}/${SubMenuRotas.EM_REVISAO_OFICIAL}`;

        case SubMenu.PARA_ASSINATURA:
            return `${urlOficioSituacao}/${SubMenuRotas.PARA_ASSINATURA}`;

        case SubMenu.PARA_ASSINATURA_PRESIDENTE:
            return `${urlOficioSituacao}/${SubMenuRotas.PARA_ASSINATURA_PRESIDENTE}`;

        case SubMenu.AGUARDANDO_RECEBIMENTO_PROCESSO_SEI:
            return `${urlOficioSituacao}/${SubMenuRotas.AGUARDANDO_RECEBIMENTO_PROCESSO_SEI}`;

        case SubMenu.PARA_ENVIO_DE_OFICIO:
            return `${urlOficioSituacao}/${SubMenuRotas.PARA_ENVIO_DE_OFICIO}`;

        case SubMenu.PENDENTE_DE_RECIBO:
            return `${urlOficioSituacao}/${SubMenuRotas.PENDENTE_DE_RECIBO}`;

        //Ofícios Enviados
        case SubMenu.ENTREGUES:
            return `${urlOficiosEnviados}/${SubMenuRotas.ENTREGUES}`;

        case SubMenu.NAO_ENTREGUES:
            return `${urlOficiosEnviados}/${SubMenuRotas.NAO_ENTREGUES}`;

        case SubMenu.COM_CERTIDAO:
            return `${urlOficiosEnviados}/${SubMenuRotas.COM_CERTIDAO}`;

        case SubMenu.CERTIDAO_PARA_ASSINATURA:
            return `${urlOficiosEnviados}/${SubMenuRotas.CERTIDAO_PARA_ASSINATURA}`;

        case SubMenu.PARA_JUNTADA:
            return `${urlOficiosEnviados}/${SubMenuRotas.PARA_JUNTADA}`;

        case SubMenu.CONCLUIDOS:
            return `${urlOficiosEnviados}/${SubMenuRotas.CONCLUIDOS}`;

        //Protocolo de Ofícios para Envio
        case SubMenu.PROTOCOLOS_PENDENTES_DE_ENVIO:
            return `${urlProtocoloDeOficios}/${SubMenuRotas.PROTOCOLOS_PENDENTES_DE_ENVIO}`;

        case SubMenu.PROTOCOLOS_PENDENTES_DE_RECIBO:
            return `${urlProtocoloDeOficios}/${SubMenuRotas.PROTOCOLOS_PENDENTES_DE_RECIBO}`;

        case SubMenu.PROTOCOLOS_PARA_CORRECAO_DE_RECIBO:
            return `${urlProtocoloDeOficios}/${SubMenuRotas.PROTOCOLOS_PARA_CORRECAO_DE_RECIBO}`;

        default:
            return null
    }
}    